import { compose } from 'ramda';

import { getOfferType, isCommercial } from './offer_type';

export const getIsCommercialByOffer = compose(isCommercial, getOfferType);
